import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import {
    deleteTrackerTestEventCodeAsync,
    getTestEventDetailAsync,
    getTestEventsOrRequestsAsync,
    getTrackerTestEventCodeAsync,
    postTrackerTestEventCodeAsync,
    putTrackerTestEventCodeAsync,
} from "../../../../redux/slices/testEvents/testEvents.asyncActions";
import {
    clearState,
    nextPage,
    prevPage,
    selectPage,
    setActiveTab,
    setTrackerId,
} from "../../../../redux/slices/testEvents/testEvents.slice";
import TestEvents from "./TestEvents.layout";

const mapStateToProps = (state) => ({
    language: state.languagesState.languages,
    eventsList: state.testEvents.eventsList,
    requestsList: state.testEvents.requestsList,
    trackerTestEventCode: state.testEvents.trackerTestEventCode,
    eventDetails: state.testEvents.eventDetails,
    activeTab: state.testEvents.activeTab,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchGetTrackerTestEventCode: () =>
        dispatch(getTrackerTestEventCodeAsync()),
    dispatchPostTrackerTestEventCode: (payload) =>
        dispatch(postTrackerTestEventCodeAsync(payload)),
    dispatchPutTrackerTestEventCode: (payload) =>
        dispatch(putTrackerTestEventCodeAsync(payload)),
    dispatchDeleteTrackerTestEventCode: (trackerTestEventCodeId) =>
        dispatch(deleteTrackerTestEventCodeAsync(trackerTestEventCodeId)),
    dispatchGetTestEventDetail: (eventId) =>
        dispatch(getTestEventDetailAsync(eventId)),
    dispatchGetTestEventsOrRequests: (payload) =>
        dispatch(getTestEventsOrRequestsAsync(payload)),

    dispatchSetActiveTab: (tabKey) => dispatch(setActiveTab(tabKey)),

    dispatchSelectPage: (page) => dispatch(selectPage(page)),
    dispatchSetTrackerId: (trackerId) => dispatch(setTrackerId(trackerId)),
    dispatchClearState: () => dispatch(clearState()),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));
export default decorate(TestEvents);
